import React from "react";
import { useTranslation } from "react-i18next";
import BaseModal from "../../components/BaseModal";
import BaseButton from "../../components/BaseButton";
import { MODAL_TYPES } from "../../utils/emitter";
import useModalActions from "../../hooks/useModalActions";

// Покупка баллами не доставила товар (сервер вернул FULFILLMENT_FAILED и уже
// вернул баллы через REFUND). Раньше модалка покупки просто молча закрывалась —
// юзер не понимал, что произошло. Показываем объяснение + подтверждение возврата.
export default function PurchaseFailedModal() {
  const { t } = useTranslation();
  const { closeModal } = useModalActions();

  return (
    <BaseModal
      className="purchase-failed-modal"
      eventTypeModal={MODAL_TYPES.PURCHASE_FAILED}
      title={t("loyalty.purchase_failed.title")}
      description={t("loyalty.purchase_failed.text")}
    >
      <BaseButton onClick={() => closeModal(MODAL_TYPES.PURCHASE_FAILED)}>
        {t("loyalty.purchase_failed.ok_btn")}
      </BaseButton>
    </BaseModal>
  );
}
